import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Twee letters voor een avatar: "Sanne de Wit" wordt "SW". */
export function initialsOf(name: string, email = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) return (email[0] ?? "?").toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
